import React, { useContext, useState } from 'react';
import Slider from 'react-slick';
import { EntryContext } from '../contexts/entryContext';

import PlayButton from './PlayButton';

import DisplayContent from '../utils/DisplayContent';
import BackButton from './BackButton';

const GameHowToPlay = ({ gameDetail }) => {
    const { game, siteAssets } = useContext(EntryContext);
    const [currentSlide, setCurrentSlide] = useState(0);

    // Use custom logo images for carousel arrows
    const carouselSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <img src={siteAssets?.nextButtonImage?.ref} alt={siteAssets?.nextButtonImage?.alt} />,
        prevArrow: <img src={siteAssets?.previousButtonImage?.ref} alt={siteAssets?.previousButtonImage?.alt} />,
        beforeChange: (current, next) => setCurrentSlide(next),
        customPaging: (i) => {
            return currentSlide === i ? (
                <input tabIndex='0' type='image' src={siteAssets?.selectedDotImage?.ref} alt={siteAssets?.selectedDotImage?.alt} />
            ) : (
                <input tabIndex='0' type='image' src={siteAssets?.dotImage?.ref} alt={siteAssets?.dotImage?.alt} />
            );
        },
    };

    return (
        <>
            <img src={gameDetail?.logo?.ref} alt={`${gameDetail?.title}`} className='game-detail-logo' />
            <div className='game-detail'>
                <div className='game-desc'>
                    <div className='slider-container'>
                        <Slider {...carouselSettings}>
                            {gameDetail?.['how-to-play']?.map((item, i) => (
                                <div key={i}>
                                    <img className='game-carousel-image' src={item?.['how-to-play-image']} alt={`${item?.alt}`} />
                                    <h3 className='game-carousel-title'>{item?.title}</h3>
                                    <p className='game-carousel-description'>{item?.description}</p>
                                </div>
                            ))}
                        </Slider>
                    </div>
                </div>

                <div className='game-buttons'>
                    <DisplayContent note='Back Button' isVisible={game?.howToPlayBackButtonImage?.ref}>
                        <BackButton
                            linkTo={'/games'}
                            className={'volver'}
                            buttonSrc={game?.howToPlayBackButtonImage?.ref}
                            buttonAlt={game?.howToPlayBackButtonImage?.alt}
                            buttonAriaLabel={game?.howToPlayBackButtonImage?.alt}
                        />
                    </DisplayContent>

                    <DisplayContent note='Play Button' isVisible={game?.howToPlayPlayButtonImage}>
                        <PlayButton
                            name={`game-play-btn-${gameDetail?.tag}`}
                            gameId={gameDetail?.game_id}
                            revealGame={gameDetail}
                            tag={gameDetail?.tag}
                            className='game-play-btn'
                            asset={game?.howToPlayPlayButtonImage}
                        />
                    </DisplayContent>
                </div>
            </div>
        </>
    );
};

export default GameHowToPlay;
